import React from 'react'
import { useTranslation } from "react-i18next"

const useLanguage = () => {
    const [t, i18n] = useTranslation('common');
    return t
}

export default useLanguage

